import { useState, useEffect } from 'react';

interface TypewriterProps {
  text: string;
  speed?: number;
  startDelay?: number;
  loop?: boolean;
  className?: string;
  cursor?: boolean;
}

export function Typewriter({
  text,
  speed = 40,
  startDelay = 150,
  loop = false,
  className,
  cursor = true,
}: TypewriterProps) {
  const [out, setOut] = useState("");

  useEffect(() => {
    let i = 0;
    let interval: NodeJS.Timeout;
    let timeout: NodeJS.Timeout;

    const start = () => {
      interval = setInterval(() => {
        i += 1;
        setOut(text.slice(0, i));
        if (i >= text.length) {
          clearInterval(interval);
          if (loop) {
            i = 0;
            timeout = setTimeout(start, 1200);
          }
        }
      }, speed);
    };

    timeout = setTimeout(start, startDelay);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [text, speed, startDelay, loop]);

  return (
    <span className={className}>
      <span>{out}</span>
      {cursor && (
        <span data-testid="type-caret" aria-hidden className="inline-block translate-y-[0.12em] animate-pulse">_</span>
      )}
    </span>
  );
}
